import { Link } from "react-router-dom";
import { allImagesPath, footerData } from "../lib/constants/ConstantsData";

const Footer = () => {
  return (
    <div className="bg-featureProBg bg-cover bg-no-repeat px-4 py-8 sm:py-10 md:py-12 lg:py-16 xl:py-20 2xl:py-24">
      {/* Top Section */}
      <div className="mx-auto max-w-[90%] sm:max-w-[85%] md:max-w-[80%] lg:max-w-[90%] xl:max-w-[1400px]">
        <div className="text-center lg:text-start grid gap-6  sm:gap-8 md:gap-10 lg:grid-cols-2 lg:gap-12 xl:gap-16">
          {/* Newsletter Section */}
          <div className="text-center lg:text-start space-y-3 xl:ml-3 sm:space-y-4 md:space-y-5 lg:space-y-6">
            <h2 className="text-xl font-sfPro font-bold text-white sm:text-2xl md:text-3xl lg:text-3xl xl:text-4xl">
              Join Our Newsletter
            </h2>
            <p className="text-sm text-white font-sfPro sm:text-base md:text-lg lg:text-lg xl:text-xl">
              Stay up to date with the latest news
            </p>
            <div className="flex w-full max-w-[370px] mx-auto lg:mx-0 overflow-hidden rounded-full bg-white p-2 py-2 sm:max-w-md md:max-w-lg lg:max-w-md lg:p-2 lg:py-2 xl:max-w-lg">
              <input
                type="text"
                placeholder="Email Address"
                className="flex-1 px-2 py-2 text-sm font-sfPro outline-none sm:py-3 sm:text-base"
              />
              <button className="ml-[-30px] font-sfPro rounded-full bg-black px-6 py-2 text-sm text-white transition hover:bg-gray-900 sm:px-8 sm:py-3 sm:text-base md:px-10">
                Send
              </button>
            </div>
          </div>

          {/* Heading Section */}
          <div className="mt-8 text-center lg:mt-0 lg:text-right">
            <h1 className="lg:text-start font-heading text-xl leading-snug text-white sm:text-3xl sm:leading-snug md:text-4xl md:leading-snug   lg:leading-snug   xl:leading-snug 2xl:text-5xl 2xl:leading-snug">
              It All Starts With a Conversation.
            </h1>
          </div>
        </div>

        {/* Middle Section */}
        <div className="mt-12   grid gap-8 sm:mt-16 sm:gap-10 md:mt-20 md:gap-12 lg:mt-24 lg:grid-cols-2 lg:gap-16 xl:mt-28 xl:gap-20">
          {/* Map */}
          <div className="flex justify-center lg:justify-start">
            <img
              src={allImagesPath.mapImage}
              className="w-full max-w-xs object-contain sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
              alt="World Map"
            />
          </div>

          {/* Links Section */}
          <div className="grid gap-6 grid-cols-2 sm:gap-8 md:grid-cols-3 md:gap-6 lg:gap-8 xl:gap-1">
            {/* {footerData.map((section, index) => (
              <div key={index} className="space-y-3 sm:space-y-4">
                <h3 className="text-base font-sfPro font-bold text-white sm:text-lg md:text-xl lg:text-2xl">
                  {section.heading}
                </h3>
 

                <ul className="cursor-pointer space-y-2 sm:space-y-3 ">
  {section.points.map((point, Index) => (
    <li
      key={Index}
      className="flex items-center text-xs font-sfPro text-white transition-all duration-300 hover:scale-105 sm:text-sm md:text-base lg:text-sm xl:text-lg"
    >
      {section.isIcon && section.icons[Index] && (
        <a
          href={section.iconLinks?.[Index] || "#"}
          target={section.iconLinks?.[Index]?.startsWith("http") ? "_blank" : "_self"}
          rel="noopener noreferrer"
        >
          <img
            src={section.icons[Index]}
            alt=""
            className="mr-2 h-4 w-4 sm:h-5 sm:w-5 lg:h-6 lg:w-6"
          />
        </a>
      )}
      <Link to={section?.links?.[Index] || "#"}>{point}</Link>
    </li>
  ))}
</ul>

              </div>
            ))} */}

            {footerData.map((section, index) => (
              <div key={index} className="space-y-3 sm:space-y-4  ">
                <h3 className="text-base font-sfPro font-bold text-white sm:text-lg md:text-xl lg:text-2xl ">
                  {section.heading}
                </h3>
                <ul className="cursor-pointer space-y-2 sm:space-y-3">
                  {section.points.map((point, i) => {
                    const icon = section.icons?.[i];
                    const link = section.iconLinks?.[i] || section.links?.[i] || "#";
                    const isExternal = typeof link === "string" && link.startsWith("https");


                    return (
                      <li
                        key={i}
                        className="flex items-center text-xs font-sfPro text-white transition-all duration-300 hover:scale-105 sm:text-sm md:text-base lg:text-sm xl:text-lg"
                      >
                        {section.isIcon && icon ? (
                          <a
                            href={link}
                            target={isExternal ? "_blank" : "_self"}
                            rel={isExternal ? "noopener noreferrer" : undefined}
                            className="flex items-center w-full gap-2"
                          >
                            <img
                              src={icon}
                              alt=""
                              className="h-4 w-4 flex-shrink-0 sm:h-5 sm:w-5 lg:h-6 lg:w-6"
                            />
                            <span className="break-all flex-1">{point}</span>
                          </a>
                        ) : (
                          <Link to={link}>{point}</Link>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Bottom Section */}
      <div className="border-white/20 mt-10 border-t pt-6 sm:mt-12 sm:pt-8 md:mt-16 lg:mt-20 xl:mt-24">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 sm:max-w-xl sm:flex-row sm:gap-6 lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl">
          <p className="text-center text-[10px] font-sfPro text-white sm:text-left sm:text-xs md:text-sm lg:text-base">
            Copyright © {new Date().getFullYear()}. Esclatech. All Rights Reserved.{" "}
            <Link to="/privacy-policy" className="text-bold  ">
              Privacy Policy
            </Link>{" "}
            |{" "}
            <Link to="/terms-and-conditions" className="text-bold  ">
              Terms & conditions
            </Link>{" "}
          </p>
          <div className="flex items-center cursor-pointer">
            <img
              src="/images/home/payment_method.png"
              alt="Payment Methods"
              className="h-5 sm:h-6 md:h-7 lg:h-9"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
